import { Namespace, useT } from "@racoon/i18n";
import { useToast } from "@racoon/ui";
import { useFileUpload } from "./useFileUpload";
import { validateContractFile } from "../lib/fileUploadUtils";

/**
 * Opens the file dialog for a contract document and hands over only files that
 * pass `validateContractFile`; a rejected file is reported with a toast instead.
 * Shared by the customer card's contract form and the onboarding wizard.
 */
export function useContractFilePicker(onPick: (file: File) => void) {
  const t = useT();
  const { toast } = useToast();

  return useFileUpload({
    onFileSelect: (file) => {
      const validationError = validateContractFile(file);
      if (validationError) {
        toast({
          variant: "destructive",
          description: t(
            Namespace.Common,
            validationError === "size" ? "fileTooLarge" : "fileTypeNotAllowed",
          ),
        });
        return;
      }
      onPick(file);
    },
  });
}
